import { useDispatch } from 'react-redux'
import {
  actionResetPaymentProfiles,
  actionGetPaymentProfiles,
  actionGetPaymentProfileById,
  actionDropPaymentProfiles,
  actionCreatePaymentProfile,
} from 'modules/Finance/PaymentProfiles/store/actions'
import { useCallback } from 'react'

export const usePaymentProfiles = () => {
  const dispatch = useDispatch()

  const getPaymentProfiles = useCallback((props) => dispatch(actionGetPaymentProfiles(props)), [])

  const createPaymentProfile = useCallback(
    (props) =>
      new Promise((resolve, reject) =>
        dispatch(actionCreatePaymentProfile({ meta: { resolve, reject }, ...props })),
      ),
    [],
  )

  const getPaymentProfileById = useCallback(
    (props) =>
      new Promise((resolve, reject) =>
        dispatch(actionGetPaymentProfileById({ meta: { resolve, reject }, ...props })),
      ),
    [],
  )

  const resetPaymentProfiles = useCallback(() => dispatch(actionResetPaymentProfiles()), [])

  const dropPaymentProfiles = useCallback(() => dispatch(actionDropPaymentProfiles()), [])

  return {
    getPaymentProfiles,
    resetPaymentProfiles,
    getPaymentProfileById,
    dropPaymentProfiles,
    createPaymentProfile,
  }
}
